// extracted by mini-css-extract-plugin
export default {"container":"LVjB-","header":"LtPqX","content":"b9mGB","controls":"tbTIu","isLayoutTextOnImage":"_7w0D-"};